import React from 'react';
import _ from 'lodash';
import {safeMult, safeDivide, fillArray} from 'common/utils';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';
import {
  TextBoxField,
  InlineSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Form, Grid} from 'semantic-ui-react';

export class CostShareItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded,
      editable: this.props.editable,
      deleteItemModalOpen: false,

      isModelActive: props.isModelActive,

      newItem: this.props.item,
    };
  }

  getNameFromId = (selectedOptionId, options) => {
    const selectedObj = _.find(options, (option) => {
      return _.isEqual(option.value, selectedOptionId);
    });
    if (!selectedObj) return;
    return selectedObj.text;
  };

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(this.props.totalNonFedShare, prevProps.totalNonFedShare)) {
      this.calculateNonFedSharePercentForLine(this.props.item.amount);
    }
  }

  handleItemModification = (value, fieldName, id) => {
    let CopynewItem = Object.assign({}, this.state.newItem);
    _.set(CopynewItem, fieldName, value);
    this.setState({newItem: CopynewItem});

    // or get changes from parents
    if (fieldName === 'amount') {
      this.calculateNonFedSharePercentForLine(value, id);
    }

    if (!this.props.isModelActive) {
      this.props.handleItemChange(CopynewItem, id, fieldName);
    }
  };

  //Calculate the Non-Fed % of the new Funding Source (inside modal) e.g. (new amount / total Funding Sources amount)
  calculateNonFedSharePercentForLine(value, id) {
    const totalNonFedShare = fillArray(_.get(this.props, 'totalNonFedShare', []), '0.00');
    let CopynewItem = Object.assign({}, this.state.newItem);
    let nonFedSharePercentValue = null;
    if (value && totalNonFedShare) {
      nonFedSharePercentValue = safeDivide(
        safeMult(value, 100),
        _.sum(_.map(totalNonFedShare, _.toNumber))
      ).toFixed(2);
    }
    _.set(CopynewItem, 'amount', value);
    _.set(
      CopynewItem,
      'nonFedSharePercent',
      nonFedSharePercentValue ? nonFedSharePercentValue : null
    );
    this.setState({newItem: CopynewItem});
  }

  // Replace addAddCostShareItemOnBlur
  CostShareItem = (fieldName) => {
    const {handleBlur} = this.props;
    handleBlur(this.state.newItem, fieldName, this.props.id);
  };

  handleValidation = (path, optionalPath, fieldName, id) => {
    const {validationErrors, validationDirtyMap, validationErrorPath} = this.props;
    const baiscPath = validationErrorPath ? `${validationErrorPath}.${path}.${optionalPath}.${id}.${fieldName}` : `${path}.${optionalPath}.${id}.${fieldName}`;
    let ruleResult = '';
    const getErrors = validationErrors ? _.get(validationErrors.errors, baiscPath) : null;
    if (_.isArray(getErrors)) {
      ruleResult = _.find(getErrors, (err) => {
        return err.isValid === false;
      });
    } else if (_.isObject(getErrors)) {
      ruleResult = getErrors;
    }
    const getDirtyMap = validationErrors
      ? _.get(validationDirtyMap, `${path}.${id}.${fieldName}`)
      : null;
    return {
      isSectionValid: validationErrors
        ? _.get(validationErrors.errors, `${path}.${optionalPath}.${id}.${'isValid'}`)
        : null,
      isTotalValid: validationErrors
        ? _.get(validationErrors.errors, `${path}.${optionalPath}.${'isValid'}`)
        : null,
      isDirty: getDirtyMap,
      rule: ruleResult,
    };
  };

  renderFirstSection = () => {
    const {id, type} = this.props;
    let error = this.handleValidation('costshare', '0', 'fundingSourceId', id);

    return (
      <div>
        <TextBoxField
          label="Funding source"
          maxLength={101}
          id={type === 'ground' ? `funding-source-ground-${id}` : `funding-source-${id}`}
          title="Funding source"
          name={`fundingSourceId`}
          value={this.state.newItem.fundingSourceId}
          handleChange={(e) => {
            this.handleItemModification(e.target.value, 'fundingSourceId', id);
          }}
          handleBlur={() => this.CostShareItem(`fundingSourceId`)}
          displayError={
            error && error.rule && error.rule.isValid === false && error.isDirty === true
          }
          errorMessages={error && error.rule && error.rule.message}
        />
      </div>
    );
  };

  renderSecondSection = () => {
    const {item, id} = this.props;
    let error = this.handleValidation('costshare', '0', 'fundingSourceName', id);
    let amountError = this.handleValidation('costshare', '0', 'amount', id);
    return (
      <React.Fragment>
        <div class="app-form-block _40">
          <div className="questionText">Name of source agency</div>
          <Form.Field>
            <TextBoxField
              maxLength={51}
              id={`source-agency-${id}`}
              name="fundingSourceName"
              value={this.state.newItem.fundingSourceName}
              handleChange={(e) => {
                this.handleItemModification(e.target.value, 'fundingSourceName', id);
              }}
              handleBlur={() => this.CostShareItem(`fundingSourceName`)}
              displayError={
                error &&
                error.rule &&
                error.rule.isValid === false &&
                error.isDirty === true
              }
              errorMessages={error && error.rule && error.rule.message}
            />
          </Form.Field>
        </div>
        <div class="app-form-block _20">
          <div id={`amount-${id}`} className="questionText">
            Funding amount
          </div>
          <Form.Field>
            <InlineDollarField
              className="rightAligned"
              id={`amount-${id}`}
              name="amount"
              maxLength={19}
              value={this.state.newItem.amount}
              handleChange={(name, value) => {
                this.handleItemModification(value, 'amount', id);
              }}
              handleBlur={() => this.CostShareItem(`amount`)}
              displayError={
                amountError &&
                amountError.rule &&
                amountError.rule.isValid === false &&
                amountError.isDirty === true
              }
              errorMessages={amountError && amountError.rule && amountError.rule.message}
            />
          </Form.Field>
        </div>
        <div class="app-form-block unit_total">
          <div id={`non-fed-share-percent-${id}`} className="questionText">
            % Non-federal share by source
          </div>
          <div id={`non-fed-share-percent-${id}`} className="center-Non-Fed">
            {' '}
            {this.state.newItem.nonFedSharePercent}
            {this.state.newItem.nonFedSharePercent ? '%' : ''}
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderThirdSection = () => {
    const {item, itemConfig, id} = this.props;

    let errorfundingTypeId = this.handleValidation('costshare', '0', 'fundingTypeId', id);
    let fundAvailabilityDate = this.handleValidation(
      'costshare',
      '0',
      'fundAvailabilityDate',
      id
    );
    let fundCommitmentLetterDate = this.handleValidation(
      'costshare',
      '0',
      'fundCommitmentLetterDate',
      id
    );

    return (
      <React.Fragment>
        <div class="app-form-block _40">
          <div className="questionText">
            <br />
            Funding type
          </div>
          <Form.Field>
            <InlineSelect
              id={`funding-type-${id}`}
              name="fundingTypeId"
              options={itemConfig.fundingTypeOptions}
              value={this.state.newItem.fundingTypeId}
              handleChange={(e) =>
                this.handleItemModification(e.target.value, 'fundingTypeId', id)
              }
              handleBlur={() => this.CostShareItem(`fundingTypeId`)}
              displayError={
                errorfundingTypeId &&
                errorfundingTypeId.rule &&
                errorfundingTypeId.rule.isValid === false &&
                errorfundingTypeId.isDirty === true
              }
              errorMessages={
                errorfundingTypeId &&
                errorfundingTypeId.rule &&
                errorfundingTypeId.rule.message
              }
            />
          </Form.Field>
        </div>
        <div class="app-form-block _25">
          <div id={`availability-date-${id}`} className="questionText">
            Date of availability <br />
            (MM/DD/YYYY)
          </div>
          <Form.Field>
            <TextBoxField
              name="fundAvailabilityDate"
              id={`availability-date-${id}`}
              value={this.state.newItem.fundAvailabilityDate}
              handleChange={(e) => {
                this.handleItemModification(e.target.value, 'fundAvailabilityDate', id);
              }}
              handleBlur={() => this.CostShareItem(`fundAvailabilityDate`)}
              displayError={
                fundAvailabilityDate &&
                fundAvailabilityDate.rule &&
                fundAvailabilityDate.rule.isValid === false &&
                fundAvailabilityDate.isDirty === true
              }
              errorMessages={
                fundAvailabilityDate &&
                fundAvailabilityDate.rule &&
                fundAvailabilityDate.rule.message
              }
            />
          </Form.Field>
        </div>
        <div className="app-form-block _25">
          <div id={`fundCommitmentLetterDate-${id}`} className="questionText-nonFed">
            Fund commitment letter date <br />
            (MM/DD/YYYY)
          </div>
          <Form.Field>
            <TextBoxField
              name="fundCommitmentLetterDate"
              title={'Fund commitment letter date (MM/DD/YYYY)'}
              id={`letter-date-${id}`}
              value={this.state.newItem.fundCommitmentLetterDate}
              handleChange={(e) => {
                this.handleItemModification(
                  e.target.value,
                  'fundCommitmentLetterDate',
                  id
                );
              }}
              handleBlur={() => this.CostShareItem(`fundCommitmentLetterDate`)}
              displayError={
                fundCommitmentLetterDate &&
                fundCommitmentLetterDate.rule &&
                fundCommitmentLetterDate.rule.isValid === false &&
                fundCommitmentLetterDate.isDirty === true
              }
              errorMessages={
                fundCommitmentLetterDate &&
                fundCommitmentLetterDate.rule &&
                fundCommitmentLetterDate.rule.message
              }
            />
          </Form.Field>
        </div>
      </React.Fragment>
    );
  };

  renderNonEditableSection = () => {
    const fundingTypeOptions = _.get(this.props, 'itemConfig.fundingTypeOptions', []);

    return (
      <React.Fragment>
        <Grid>
          <Grid.Row className={`noBottomPadding`}>
            <Grid.Column width={4}>
              <strong>Name of source agency</strong>
            </Grid.Column>
            <Grid.Column width={3}>
              <strong>Funding amount</strong>
            </Grid.Column>
            <Grid.Column width={3}>
              <strong>Funding type</strong>
            </Grid.Column>
            <Grid.Column width={3}>
              <strong>Date of availability</strong>
            </Grid.Column>
            <Grid.Column width={3}>
              <strong>Fund commitment letter date</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>{this.state.newItem.fundingSourceName}</Grid.Column>
            <Grid.Column width={3}>{'$' + this.state.newItem.amount}</Grid.Column>
            <Grid.Column width={3}>
              {this.getNameFromId(
                parseInt(_.get(this.state, 'newItem.fundingTypeId'), 10),
                fundingTypeOptions
              )}
            </Grid.Column>
            <Grid.Column width={3}>{this.state.newItem.fundAvailabilityDate}</Grid.Column>
            <Grid.Column width={3}>
              {this.state.newItem.fundCommitmentLetterDate}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div class="w-form">
          {this.state.editable ? (
            <Form>
              <div className="app-form-row margin-bottom-25">
                <React.Fragment>
                  <div className="app-form-block _100">
                    <Form.Field>{this.renderFirstSection()}</Form.Field>
                  </div>
                </React.Fragment>
              </div>
              <div className="app-form-row margin-bottom-25">
                {this.renderSecondSection()}
              </div>
              <div className="app-form-row margin-bottom-25">
                {this.renderThirdSection()}
              </div>
            </Form>
          ) : (
            this.renderNonEditableSection()
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default CostShareItem;
